import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Radio, LayoutGrid, Video, GraduationCap, CalendarDays, Film, Users, UserRound,
  Clock, MessageSquare, BarChart3, ShieldCheck, Settings, ChevronsLeft, ArrowLeft,
} from "lucide-react";

const NAV_ITEMS = [
  { to: "/meetings", label: "Dashboard", icon: LayoutGrid, end: true },
  { to: "/meetings/all", label: "Meetings", icon: Video },
  { to: "/meetings/classes", label: "Live Classes", icon: GraduationCap },
  { to: "/meetings/calendar", label: "Calendar", icon: CalendarDays },
  { to: "/meetings/recordings", label: "Recordings", icon: Film },
  { to: "/meetings/students", label: "Students", icon: Users },
  { to: "/meetings/participants", label: "Participants", icon: UserRound },
  { to: "/meetings/waiting-room", label: "Waiting Room", icon: Clock },
  { to: "/meetings/chat", label: "Chat", icon: MessageSquare },
  { to: "/meetings/analytics", label: "Analytics", icon: BarChart3 },
  { to: "/meetings/admin-approval", label: "Admin Approval", icon: ShieldCheck },
];

export function MeetingSidebar({ collapsed, onToggleCollapse }) {
  const navigate = useNavigate();

  return (
    <aside className={`shrink-0 bg-[#0b0f1a] border-r border-white/5 flex flex-col h-full transition-all ${collapsed ? "w-[68px]" : "w-64"}`} data-testid="meet-sidebar">
      <div className="flex items-center gap-2.5 px-4 h-16 border-b border-white/5 shrink-0">
        <button onClick={() => navigate("/dashboard")} data-testid="meet-back-to-app-btn" className="w-9 h-9 rounded-lg bg-gradient-to-br from-cyan-400 to-fuchsia-500 flex items-center justify-center shrink-0" title="Back to Cloudivo">
          <Radio className="w-4.5 h-4.5 text-white" />
        </button>
        {!collapsed && (
          <div className="leading-tight overflow-hidden">
            <p className="text-sm font-bold text-white truncate">Cloudivo Meet</p>
            <p className="text-[10px] text-slate-500 uppercase tracking-wider">Enterprise</p>
          </div>
        )}
      </div>

      <nav className="flex-1 overflow-y-auto py-3 px-2.5 space-y-0.5">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to} to={item.to} end={item.end} data-testid={`meet-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isActive ? "bg-cyan-500/15 text-cyan-300 font-semibold" : "text-slate-400 hover:text-white hover:bg-white/5"
              }`
            }
          >
            <item.icon className="w-4.5 h-4.5 shrink-0" />
            {!collapsed && <span className="truncate">{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      <div className="p-2.5 border-t border-white/5 space-y-0.5">
        <NavLink to="/meetings/settings" data-testid="meet-nav-settings" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-400 hover:text-white hover:bg-white/5">
          <Settings className="w-4.5 h-4.5 shrink-0" /> {!collapsed && "Settings"}
        </NavLink>
        <button onClick={() => navigate("/dashboard")} data-testid="meet-exit-btn" className="w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-slate-500 hover:text-white hover:bg-white/5">
          <ArrowLeft className="w-4.5 h-4.5 shrink-0" /> {!collapsed && "Exit to Cloudivo"}
        </button>
        <button onClick={onToggleCollapse} data-testid="meet-collapse-btn" className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-slate-500 hover:text-white hover:bg-white/5">
          <ChevronsLeft className={`w-4 h-4 transition-transform ${collapsed ? "rotate-180" : ""}`} />
        </button>
      </div>
    </aside>
  );
}
